import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	findByUserIdAndPostId({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`service/findByUserIdAndPostId`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  selectServiceAllTwo({ commit }, params) {//已办服务用
		return new Promise((resolve, reject) => {
			axios.post(`service/selectServiceAll`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	selectServiceAll({ commit }, params) {
		return new Promise((resolve, reject) => {
			let orderList = axios.post(`service/selectServiceAll`, params)
			let orgTree =  axios.get('/org/findOrgTreeByCurrentUser')
			Promise.all([orderList, orgTree])
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	updateService({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`service/updateService`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  revokeService({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`service/revokeService`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  dataSync({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/service/sync`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
}